(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qva-coffee-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('qva-coffee-hero')) {
    class QvaCoffeeHero extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const video = this.querySelector('video');
        video.autoplay = false;
        const narrow = matchMedia('(max-width:749px)');
        this.abort = new AbortController();
        const signal = this.abort.signal;
        let mode = '', inView = true, automaticFallback = false;
        const clearTimers = () => {clearTimeout(this.loadTimer); clearTimeout(this.stallTimer); this.loadTimer = this.stallTimer = 0;};
        const mayAutoplay = () => !automaticFallback && !navigator.connection?.saveData && !/^(slow-2g|2g)$/.test(navigator.connection?.effectiveType || '') && inView && !document.hidden;
        const showPoster = () => {
          clearTimers();
          automaticFallback = true;
          video.autoplay = false;
          video.pause();
          video.classList.remove('is-ready');
          video.removeAttribute('src');
          video.load();
          mode = '';
        };
        const start = (play) => {
          video.autoplay = play;
          const next = narrow.matches && this.dataset.mobile ? 'mobile' : 'desktop';
          if (mode !== next) {
            mode = next;
            video.classList.remove('is-ready');
            if (!this.dataset[next]) return;
            video.src = this.dataset[next];
            video.muted = true;
            video.load();
          }
          if (play) {
            clearTimers();
            this.loadTimer = setTimeout(showPoster, 15000);
            video.play().catch((error) => {if (error.name !== 'AbortError') showPoster();});
          }
        };
        video.addEventListener('playing', () => {clearTimers(); video.classList.add('is-ready');}, {signal});
        video.addEventListener('error', showPoster, {signal});
        video.addEventListener('waiting', () => {
          if (!video.paused && video.classList.contains('is-ready') && !this.stallTimer) this.stallTimer = setTimeout(showPoster, 2500);
        }, {signal});
        narrow.addEventListener('change', () => {if (mode && mayAutoplay()) start(true); else if (mode) showPoster();}, {signal});
        document.addEventListener('visibilitychange', () => {if (document.hidden) {video.autoplay = false; clearTimers(); video.pause();} else if (mayAutoplay()) start(true);}, {signal});
        const header = document.querySelector('.section-header');
        const updateHeader = () => {
          this.scrollFrame = 0;
          header?.classList.toggle('qva-hero-past', this.getBoundingClientRect().bottom <= header.getBoundingClientRect().height);
        };
        window.addEventListener('scroll', () => {if (!this.scrollFrame) this.scrollFrame = requestAnimationFrame(updateHeader);}, {passive:true, signal});
        window.addEventListener('resize', updateHeader, {passive:true, signal});
        updateHeader();
        const announcement = document.querySelector('.announcement-bar-section');
        if (announcement) {
          this.resizeObserver = new ResizeObserver(() => document.body.style.setProperty('--qva-announcement-height', announcement.getBoundingClientRect().height + 'px'));
          this.resizeObserver.observe(announcement);
        }
        this.intersectionObserver = new IntersectionObserver(([entry]) => {
          inView = entry.isIntersecting;
          if (!inView) {video.autoplay = false; clearTimers(); video.pause();}
          else if (mayAutoplay() && (!mode || video.paused)) start(true);
        });
        this.intersectionObserver.observe(this);
        this.launchFrame = requestAnimationFrame(() => {
          this.launchFrame = 0;
          if (mayAutoplay() && (!mode || video.paused)) start(true);
        });
      }
      disconnectedCallback() {
        clearTimeout(this.loadTimer);
        clearTimeout(this.stallTimer);
        cancelAnimationFrame(this.scrollFrame);
        cancelAnimationFrame(this.launchFrame);
        this.querySelector('video')?.pause();
        this.abort?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.initialized = false;
      }
    }
    customElements.define('qva-coffee-hero', QvaCoffeeHero);
  }

  } catch(e) { console.error(e); }
})();
})();
